import GModalHeader from "glesys-controlpanel/components/g-modal/header";
import GModalBody from "glesys-controlpanel/components/g-modal/body";
import GModalFooter from "glesys-controlpanel/components/g-modal/footer";
import GButton from "glesys-controlpanel/components/g-button";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import { eq } from "ember-truth-helpers";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import Copyable from "glesys-controlpanel/components/copyable";

<template>
  <GModalHeader>
    {{t "component.modal.domain-show-dnssec-record.title"}}
  </GModalHeader>
  <GModalBody data-test-dnssec-record-modal>
    <p class="text-gray-500 mb-4" data-test-dnssec-record-description>
      {{#if (eq @params.record.origin "system")}}
        {{#if @params.isManagedByGlesys}}
          {{t "component.modal.domain-show-dnssec-record.description"}}
        {{else}}
          {{t "component.modal.domain-show-dnssec-record.description-external-registrar"}}
        {{/if}}
      {{else}}
        {{#if (eq @params.record.status "pending")}}
          {{t "component.modal.domain-show-dnssec-record.description-custom-record-pending"}}
        {{else}}
          {{t "component.modal.domain-show-dnssec-record.description-custom-record-published"}}
        {{/if}}
      {{/if}}
    </p>
    <table class="table-fixed w-full">
      <tbody>
        <tr class="even:bg-gray-50 odd:bg-white border-b last:border-b-0 border-gray-200">
          <th class="text-sm font-normal text-gray-500 text-left p-3 w-1/5" scope="row">
            {{t "dns.domain.dnssec.labels.flags"}}
          </th>
          <td class="p-3" data-test-dnssec-record-flags>{{@params.record.flags}}</td>
        </tr>
        <tr class="even:bg-gray-50 odd:bg-white border-b last:border-b-0 border-gray-200">
          <th class="text-sm font-normal text-gray-500 text-left p-3 w-1/5" scope="row">
            {{t "dns.domain.dnssec.labels.algorithm"}}
          </th>
          <td class="p-3" data-test-dnssec-record-algorithm>
            {{@params.record.algorithm}}
            {{@params.record.algorithmname}}
          </td>
        </tr>
        <tr class="even:bg-gray-50 odd:bg-white border-b last:border-b-0 border-gray-200">
          <th class="text-sm font-normal text-gray-500 text-left p-3 w-1/5" scope="row">
            {{t "dns.domain.dnssec.labels.public-key"}}
          </th>
          <td class="p-3">
            <Copyable>
              <div class="truncate max-w-lg" data-test-dnssec-record-public-key>{{@params.record.dnskey}}</div>
            </Copyable>
          </td>
        </tr>
        <tr class="even:bg-gray-50 odd:bg-white border-b last:border-b-0 border-gray-200">
          <th class="text-sm font-normal text-gray-500 text-left p-3 w-1/5" scope="row">
            {{t "dns.domain.dnssec.labels.key-tag"}}
          </th>
          <td class="p-3" data-test-dnssec-record-key-tag>{{@params.record.keytag}}</td>
        </tr>
        <tr class="even:bg-gray-50 odd:bg-white border-b last:border-b-0 border-gray-200">
          <th class="text-sm font-normal text-gray-500 text-left p-3 w-1/5" scope="row">
            {{t "dns.domain.dnssec.labels.digest-type"}}
          </th>
          <td class="p-3" data-test-dnssec-record-digest-type>{{@params.record.digesttype}}
            {{@params.record.digesttypename}}</td>
        </tr>
        <tr class="even:bg-gray-50 odd:bg-white border-b last:border-b-0 border-gray-200">
          <th class="text-sm font-normal text-gray-500 text-left p-3 w-1/5" scope="row">
            {{t "dns.domain.dnssec.labels.digest"}}
          </th>
          <td class="p-3">
            <Copyable>
              <div class="truncate max-w-lg" data-test-dnssec-record-digest>{{@params.record.digest}}</div>
            </Copyable>
          </td>
        </tr>
      </tbody>
    </table>
  </GModalBody>
  <GModalFooter>
    <GButton data-test-modal-domain-show-dnssec-record-close @color="outline" {{on "click" (modalClose)}}>
      {{t "button.close"}}
    </GButton>
  </GModalFooter>
</template>
